<template>
  <UserResetPasswordController
    v-if="isIdentityFirstFlow"
    :mfaType="mfaType"
    :requestKey="requestKey"
    :step="step"
  />
  <UserResetPassword
    v-else
    v-bind="$props"
  />
</template>

<script>
import { useFeatureFlags } from 'client/stores/FeatureFlag';
import UserResetPassword from 'client/containers/UserResetPassword.vue';
import UserResetPasswordController from 'client/containers/user/UserResetPassword/UserResetPasswordController.vue';

export default {
  name: 'UserResetPasswordWrapper',

  components: {
    UserResetPassword,
    UserResetPasswordController,
  },

  props: {
    clientType: {
      type: String,
      required: true,
    },
    mfaType: {
      type: String,
      default: undefined,
    },
    requestKey: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: undefined,
    },
  },

  /*
  * Code to display UserResetPasswordController for Identity First
  * @todo Remove isIdentityFirstFlow and UserResetPassword component
  * in template once the feature flag goes to production
  */
  setup() {
    const { isIdentityFirstFlow } = useFeatureFlags();
    return { isIdentityFirstFlow };
  },

};
</script>
